/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_AvailableInputs */

const en_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available for new projects`)
};

const ar_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متاح لمشاريع جديدة`)
};

const bn_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নতুন প্রজেক্ট নিচ্ছি`)
};

const de_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar für neue Projekte`)
};

const es_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible para nuevos proyectos`)
};

const fr_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible pour de nouveaux projets`)
};

const pt_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível para novos projetos`)
};

const zh_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎新的项目合作`)
};

const tr_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni projeler için uygun`)
};

const ru_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступно для новых проектов`)
};

const pl_hero_available = /** @type {(inputs: Hero_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostępne dla nowych projektów`)
};

/**
* | output |
* | --- |
* | "Available for new projects" |
*
* @param {Hero_AvailableInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_available = /** @type {((inputs?: Hero_AvailableInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_AvailableInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_available(inputs)
	if (locale === "bn") return bn_hero_available(inputs)
	if (locale === "de") return de_hero_available(inputs)
	if (locale === "es") return es_hero_available(inputs)
	if (locale === "fr") return fr_hero_available(inputs)
	if (locale === "pt") return pt_hero_available(inputs)
	if (locale === "zh") return zh_hero_available(inputs)
	if (locale === "tr") return tr_hero_available(inputs)
	if (locale === "ru") return ru_hero_available(inputs)
	if (locale === "pl") return pl_hero_available(inputs)
	return en_hero_available(inputs)
});